export default "__VITE_ASSET__C7Mu2JOZ__"